import { Reveal } from "./Reveal";

export function SectionHeading({ chapter, title, description, align = "left", testid }) {
  const centered = align === "center";
  return (
    <div className={centered ? "text-center" : ""} data-testid={testid}>
      {chapter && (
        <Reveal>
          <div
            className={`mb-5 flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.25em] text-neon/90 ${
              centered ? "justify-center" : ""
            }`}
          >
            <span className="h-px w-8 bg-neon/50" />
            {chapter}
            {centered && <span className="h-px w-8 bg-neon/50" />}
          </div>
        </Reveal>
      )}
      <Reveal delay={0.08}>
        <h2 className="font-display text-3xl font-extrabold uppercase leading-[1.05] tracking-tight text-white sm:text-4xl lg:text-5xl">
          {title}
        </h2>
      </Reveal>
      {description && (
        <Reveal delay={0.16}>
          <p
            className={`mt-5 max-w-2xl text-base leading-relaxed text-mist ${
              centered ? "mx-auto" : ""
            }`}
          >
            {description}
          </p>
        </Reveal>
      )}
    </div>
  );
}
